import { useUserContext } from '../../Contexts/UserConfig'
import { useMessagePopupContext } from '../../garvan-react/Components/ModalFeedback/MessagePopup'
import { useMutation } from 'react-query'
import { AxiosResponse } from 'axios'
import PrintingService from '../PHP/APIs/PrintingService'

export function useSendPrintVessel(card_printer: string | undefined) {
  const { whoAmI } = useUserContext()
  const { setError, setMessage } = useMessagePopupContext()
  return useMutation<any, AxiosResponse, number, () => void>(
    ['PrintingService', 'sendPrintVessel', card_printer],
    (sample_run_id) =>
      PrintingService.sendPrintVessel(whoAmI!, card_printer!, sample_run_id!),
    {
      onError: (err) => setError(err),
      onSuccess: (data, sample_run_id) => {
        if (data?.Success) {
          setMessage({
            subject: 'Success',
            severity: 'success',
            message: `V${sample_run_id} has been sent to print`,
          })
        } else {
          setMessage({
            subject: 'Error',
            severity: 'warning',
            message:
              (data as any)?.message ??
              `An unsuccessful response has been returned from printing`,
          })
        }
      },
    },
  )
}
